import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Outlet } from 'react-router-dom';
import PullToRefresh from '../../components/PullToRefresh/PullToRefresh';
import { ServiceRequestSoundContextProvider } from '../../context/AudioNotification/ServiceRequestSound';
import { CategoriesProvider } from '../../context/CategoriesContext';
import { GameScheduleProvider } from '../../context/GameScheduleContext';
import { MenuProvider } from '../../context/MenuContext';
import { NewOrderAlertsContextProvider } from '../../context/NewOrderAlerts';
import { OrderProvider } from '../../context/OrderContext';
import { OrderStadiumProvider } from '../../context/OrderStadiumContext';
import { PreorderRulesProvider } from '../../context/PreorderRulesContext/PreorderRulesContext';
import PrinterProvider from '../../context/PrinterContext';
import { SettingsProvider } from '../../context/SettingsContext';
import { UserMenuProvider } from '../../context/UserMenuContext';
import AppBar from './AppBar/AppBar';
import SideBar from './SideBar/SideBar';

const defaultTheme = createTheme();

export default function MainLayout() {
  return (
    <ThemeProvider theme={defaultTheme}>
      <ServiceRequestSoundContextProvider>
        <NewOrderAlertsContextProvider>
          <SettingsProvider>
            <PreorderRulesProvider>
              <OrderStadiumProvider>
                <CategoriesProvider>
                  <GameScheduleProvider>
                    <OrderProvider>
                      <MenuProvider>
                        <UserMenuProvider>
                          <PrinterProvider>
                            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                              <CssBaseline />
                              <AppBar />
                              <Box sx={{ display: 'flex', height: 'calc(100vh - 72px)', width: '100%' }}>
                                <SideBar />
                                <PullToRefresh>
                                  <Box
                                    sx={{
                                      height: 'calc(100vh - 72px)',
                                      overflow: 'auto',
                                      width: { xs: 'calc(100% - 82px)', sm: 'calc(100% - 280px)' },
                                    }}
                                  >
                                    <Outlet />
                                  </Box>
                                </PullToRefresh>
                              </Box>
                            </Box>
                          </PrinterProvider>
                        </UserMenuProvider>
                      </MenuProvider>
                    </OrderProvider>
                  </GameScheduleProvider>
                </CategoriesProvider>
              </OrderStadiumProvider>
            </PreorderRulesProvider>
          </SettingsProvider>
        </NewOrderAlertsContextProvider>
      </ServiceRequestSoundContextProvider>
    </ThemeProvider>
  );
}
